/* tslint:disable */
/* eslint-disable */
/**
 * Validations API
 * Validator side of the quote validation requests
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * One answered question of the quote questionnaire, as displayed.
 * @export
 * @interface QuestionnaireDevisReponseDto
 */
export interface QuestionnaireDevisReponseDto {
    /**
     * 
     * @type {string}
     * @memberof QuestionnaireDevisReponseDto
     */
    questionId: string;
    /**
     * 
     * @type {string}
     * @memberof QuestionnaireDevisReponseDto
     */
    libelle: string;
    /**
     * 
     * @type {string}
     * @memberof QuestionnaireDevisReponseDto
     */
    reponse: string;
}

/**
 * Check if a given object implements the QuestionnaireDevisReponseDto interface.
 */
export function instanceOfQuestionnaireDevisReponseDto(value: object): value is QuestionnaireDevisReponseDto {
    if (!('questionId' in value) || value['questionId'] === undefined) return false;
    if (!('libelle' in value) || value['libelle'] === undefined) return false;
    if (!('reponse' in value) || value['reponse'] === undefined) return false;
    return true;
}

export function QuestionnaireDevisReponseDtoFromJSON(json: any): QuestionnaireDevisReponseDto {
    return QuestionnaireDevisReponseDtoFromJSONTyped(json, false);
}

export function QuestionnaireDevisReponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): QuestionnaireDevisReponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'questionId': json['questionId'],
        'libelle': json['libelle'],
        'reponse': json['reponse'],
    };
}

export function QuestionnaireDevisReponseDtoToJSON(json: any): QuestionnaireDevisReponseDto {
    return QuestionnaireDevisReponseDtoToJSONTyped(json, false);
}

export function QuestionnaireDevisReponseDtoToJSONTyped(value?: QuestionnaireDevisReponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'questionId': value['questionId'],
        'libelle': value['libelle'],
        'reponse': value['reponse'],
    };
}

